function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.28613 17.7858V6.21434C4.28613 5.15062 5.1506 4.28577 6.2147 4.28577H17.7861C18.8502 4.28577 19.7147 5.15062 19.7147 6.21434V17.7858C19.7147 18.8495 18.8502 19.7143 17.7861 19.7143H6.2147C5.1506 19.7143 4.28613 18.8495 4.28613 17.7858ZM17.7861 17.7858V6.21434H6.2147V17.7858H17.7861ZM15.3754 13.9286C16.0384 13.9286 16.0082 12.9643 15.3754 12.9643H8.62542C7.99261 12.9643 7.99261 13.9286 8.62542 13.9286H15.3754ZM13.4468 15.8572H8.62542C7.96247 15.8572 7.99261 14.8929 8.62542 14.8929H13.4468C14.0495 14.8929 14.1098 15.8572 13.4468 15.8572ZM13.929 11.0358C14.994 11.0358 15.8576 10.1723 15.8576 9.1072C15.8576 8.04206 14.994 7.17862 13.929 7.17862C12.8639 7.17862 12.0004 8.04206 12.0004 9.1072C12.0004 10.1723 12.8639 11.0358 13.929 11.0358ZM10.0718 7.17862L8.14328 11.0358H12.0004L10.0718 7.17862Z",
  fill: "#1194DA"
});

var SvgInApp = function SvgInApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in-app.ee71425e.svg";
export { ForwardRef as ReactComponent };